<template>
  <div style="max-width: 1500px" class="mx-auto px-5">
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-btn @click="getPedidos()" :loading="loading" color="primary" text>
        <v-icon left>mdi-refresh</v-icon> Atualizar
      </v-btn>
    </v-toolbar>
    <v-row>
      <v-col cols="12" xl="6">
        <v-card :loading="loading">
          <v-card-title>
            <v-icon left color="orange">mdi-clock</v-icon> Pendente Aprovação
          </v-card-title>
          <v-data-table
            :items="pendente_aprovacao"
            :headers="headers"
            sort-by="created_at"
            sort-desc
          >
            <template v-slot:item.numero="{ item }">
              <router-link
                :to="{ name: 'edit_pedido', params: { numero: item.numero } }"
              >
                {{ item.numero }}
              </router-link>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span :title="item.created_at">
                {{ item.created_at_diff }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6">
        <v-card :loading="loading">
          <v-card-title>
            <v-icon left color="orange">mdi-book-open-variant</v-icon> Em aberto
          </v-card-title>
          <v-data-table
            :items="em_aberto"
            :headers="headers"
            sort-by="created_at"
            sort-desc
          >
            <template v-slot:item.numero="{ item }">
              <router-link
                :to="{ name: 'edit_pedido', params: { numero: item.numero } }"
              >
                {{ item.numero }}
              </router-link>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span :title="item.created_at">
                {{ item.created_at_diff }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6">
        <v-card :loading="loading">
          <v-card-title>
            <v-icon left color="red">mdi-cancel</v-icon> Recusados recentemente
          </v-card-title>
          <v-data-table
            :items="recusados_recentemente"
            :headers="headers"
            sort-by="created_at"
            sort-desc
          >
            <template v-slot:item.numero="{ item }">
              <router-link
                :to="{ name: 'edit_pedido', params: { numero: item.numero } }"
              >
                {{ item.numero }}
              </router-link>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span :title="item.created_at">
                {{ item.created_at_diff }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6">
        <v-card :loading="loading">
          <v-card-title>
            <v-icon left color="green">mdi-check</v-icon> Aprovados recentemente
          </v-card-title>
          <v-data-table
            :items="aprovados_recentemente"
            :headers="headers"
            sort-by="created_at"
            sort-desc
          >
            <template v-slot:item.numero="{ item }">
              <router-link
                :to="{ name: 'edit_pedido', params: { numero: item.numero } }"
              >
                {{ item.numero }}
              </router-link>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span :title="item.created_at">
                {{ item.created_at_diff }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from "@/services/dashboard";
import MoneyMixin from "@/mixins/MoneyMixin";

export default {
  components: {},
  mixins: [MoneyMixin],
  data: () => ({
    pendente_aprovacao: [],
    em_aberto: [],
    recusados_recentemente: [],
    aprovados_recentemente: [],
    loading: false,
    headers: [
      {
        text: "Pedido",
        value: "numero"
      },
      {
        text: "Cliente",
        value: "cliente_nome"
      },
      {
        text: "Vendedor",
        value: "vendedor_nome"
      },
      {
        text: "Data",
        value: "created_at"
      }
    ]
  }),
  methods: {
    async getPedidos() {
      this.loading = true;

      try {
        const response = await get();
        this.pendente_aprovacao = response.pendente_aprovacao;
        this.em_aberto = response.em_aberto;
        this.recusados_recentemente = response.recusados_recentemente;
        this.aprovados_recentemente = response.aprovados_recentemente;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível carregar os dados",
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.getPedidos();
  }
};
</script>
